import Vue from "vue";
import Vuex from "vuex";

// Modules
import auth from "./store/auth.module";
import rest from "./store/REST.module";
import test from "./store/test/test.module"
import educationDetail from "@/core/services/store/education/educationDetail.module"
import interactiveVideo from "@/core/services/store/interactive-video/interactive-video.module"
import mandatory from "./store/mandatory.module"
import dashboard from "./store/dashboard.module"
import dashboardAzcon from "./store/dashboardAzcon.module"

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        rest,
        test,
        educationDetail,
        interactiveVideo,
        mandatory,
        dashboard,
        dashboardAzcon
    }
});

